import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PortalMessage {
    messageId: string;
    title: string;
    body: string;
    displayType: number;
}

export interface PortalMessagesResponse {
    portalMessages: PortalMessage[];
    count: number;
}

export interface MessageBody {
    messageId: string;
    applicationIds: string[]
}




@Injectable()
export class PortalMessageService {
    private baseUrl = '/api';
    private headers() {
        return new HttpHeaders({
            Authorization: `Bearer ${sessionStorage.getItem('authorizationData')}`,
        });
    }
    constructor (protected httpClient: HttpClient) { }

    public getPortalMessages(): Observable<PortalMessagesResponse> {
        return this.httpClient.post<PortalMessagesResponse>(`${this.baseUrl}/portalmessages/live`, {}, { headers: this.headers() });
    }

    public readMessage(body: MessageBody): Observable<any> {
        return this.httpClient.patch(`${this.baseUrl}/portalmessages/read`, body, { headers: this.headers() });
    }

    public dismissMessage(body: MessageBody): Observable<any> {
        return this.httpClient.patch(`${this.baseUrl}/portalmessages/dismiss`, body, { headers: this.headers() });
    }




}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/portal-messages.service.ts